import $ from "jquery"; // Import jQuery
import "./js/main.js"; // Import your main JavaScript file
import "bootstrap-sass"; // Import Bootstrap-Sass
import "./sass/index.scss"; // Import your SCSS file
